import * as React from 'react'
import NumberFormat from 'react-number-format';
import { TerminalNodeInterpreter } from '../model/TerminalNodeInterpreter';
import { TerminalScoreContext } from '../TerminalScoreProvider';
import TerminalStat from './TerminalStat';


type Props = {
  nodeId: string,
  className?: string
}

const MINIMUM_CAPACITY_SAT = 500000;

const TerminalMinimumMedianCapacity: React.FC<Props> = ({ nodeId, className = '' }) => {
  const { graph, terminalScore } = React.useContext(TerminalScoreContext);

  const edges = graph.getEdges(nodeId);

  let medianCapacity = 0;
  if (edges.length === 1) {
    medianCapacity = edges[0].capacitySat;
  } else if (edges.length > 1) {
    const capacities = edges.map(e => e.capacitySat);
    capacities.sort((a,b) => b-a);
    const middleIndex = Math.round(capacities.length / 2);
    medianCapacity = capacities[middleIndex]; 
  }


  const isBelowMinimum = medianCapacity < MINIMUM_CAPACITY_SAT;

  return (
    <TerminalStat label="Median channel capacity" value={
      <NumberFormat displayType={'text'} thousandSeparator={true} suffix="sat" value={medianCapacity} />
    } isMatched={!isBelowMinimum} />
  );
}

export default TerminalMinimumMedianCapacity;

